(function(){
'use strict';

angular.module('classy').component('formRow', {
  template: '<div class="form-table__row" data-ng-transclude></div>',
  transclude: true
});
})();